import styled from 'styled-components';
import Baseball from '../../../common/components/js/sports/Baseball';

interface IProps {
  npb: {
    isShow: boolean;
    games?: Array<{
      url: string;
      teamHome: string;
      teamVisitor: string;
    }>;
    date?: string;
  };
  mlb: {
    isShow: boolean;
    players?: Array<{
      url: string;
      name: string;
    }>;
    date?: string;
  };

  hasTitle: boolean; // モジュールタイトルを表示する
}
const BaseballWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
`;

const TopBaseball: React.FC<IProps> = props => {
  if (!props.npb.isShow && !props.mlb.isShow) {
    return null;
  }
  return (
    <BaseballWrapper>
      <Baseball npb={props.npb} mlb={props.mlb} hasTitle={props.hasTitle} />
    </BaseballWrapper>
  );
};

export default TopBaseball;
